import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// tailwind.config.js で足したチャットv2 の文字サイズ・影（text-tk-13 / shadow-tk-card など）を
// tailwind-merge に教える。教えないと text-tk-13 を文字色とみなし、text-tk-text-2 と並べたときに消してしまう。
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["tk-12", "tk-13", "tk-14", "tk-16", "tk-18", "tk-28"] }],
      shadow: [{ shadow: ["tk-raised", "tk-card", "tk-overlay", "tk-modal", "tk-stage"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
